import { create } from 'zustand';

interface ExpertsStore {
  /** Whether the expert editing modal is open. */
  isEditingExpert: boolean;
  /** Set whether the expert editing modal is open. */
  setIsEditingExpert: (isEditingExpert: boolean) => void;
  /** Whether the expert editing modal is open. */
  isSyncingExpert: boolean;
  /** Set whether the expert editing modal is open. */
  setIsSyncingExpert: (isSyncingExpert: boolean) => void;
  /** The ID of the selected expert. */
  selectedExpertId: string;
  /** Set the ID of the selected expert. */
  setSelectedExpertId: (expertId: string) => void;
  /** Whether the archive expert modal is open. */
  archiveModalIsOpen: boolean;
  /** Set whether the archive expert modal is open. */
  setArchiveModalIsOpen: (isOpen: boolean) => void;
  /** Whether the updating expert modal is open. */
  updatingExpertModalIsOpen: boolean;
  /** Set whether the updating expert modal is open. */
  setUpdatingExpertModalIsOpen: (isOpen: boolean) => void;
}

export const useExpertsStore = create<ExpertsStore>((set) => ({
  isEditingExpert: false,
  setIsEditingExpert: (isEditingExpert) => set({ isEditingExpert }),
  isSyncingExpert: false,
  setIsSyncingExpert: (isSyncingExpert) => set({ isSyncingExpert }),
  selectedExpertId: '',
  setSelectedExpertId: (expertId) => set({ selectedExpertId: expertId }),
  archiveModalIsOpen: false,
  setArchiveModalIsOpen: (isOpen) => set({ archiveModalIsOpen: isOpen }),
  updatingExpertModalIsOpen: false,
  setUpdatingExpertModalIsOpen: (isOpen) => set({ updatingExpertModalIsOpen: isOpen }),
}));
